import { createReduxAsyncThunk } from 'shared/utils';

import { mapApi } from '../../api';

import { MAP_STATE } from '../../constants';

import { PlannedRoutes, PlannedRoutesPricesFilter, PlannedRoutesPrices } from '../../types';

interface GetPlannedRoutesPricesArg {
  planId: PlannedRoutes['planId'];
  filter: PlannedRoutesPricesFilter;
}

export const getPlannedRoutesPrices = createReduxAsyncThunk<PlannedRoutesPrices, GetPlannedRoutesPricesArg>(
  `${MAP_STATE}/getPlannedRoutesPrices`,
  async ({ planId, filter }) => {
    const { data } = await mapApi.getPlannedRoutesPrices(planId, filter);
    return data;
  }
);
